import { render, staticRenderFns } from "./Couriers.vue?vue&type=template&id=4c172286&"
import script from "./Couriers.vue?vue&type=script&lang=ts&"
export * from "./Couriers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports